// ── An Ongoing's CONVERSATIONS, as the Briefing counts and lists them (busy-my-web#654) ─────────
//
// One read per Ongoing — `GET v1/chat/sessions?scope=ongoing:<id>` → `{ live, recent[], count }` —
// kept by Ongoing id so the strip's "3 Conversations" row and the list it opens are one answer.
// What the row SAYS and which sessions it lists are lib/ongoingConversations.js's.
//
// Signed-in only and silent on failure, like every chat read: a conversation list that could not
// be fetched is a Briefing without that row, never an error on the way into a story.

import api from '@/lib/services/general.service'
import { scopeString } from '@/lib/askScope'
import { CONVERSATIONS_TAKE, conversationCount, conversationRows } from '@/lib/ongoingConversations'

const unwrap = (res) => res?.data?.data ?? res?.data ?? null
const key = (id) => String(id || '')

export const state = {
  // { [ongoingId]: { status: 'loading' | 'ready' | 'error', data } }
  byId: {},
}

export const getters = {
  count: (s) => (id) => conversationCount(s.byId[key(id)]?.data || null),
  rows: (s) => (id) => conversationRows(s.byId[key(id)]?.data || null),
  status: (s) => (id) => s.byId[key(id)]?.status || 'idle',
}

export const actions = {
  /** Read this Ongoing's conversations, once — `force` reads again (a save has just landed here). */
  async ensure({ commit, state: s, rootGetters }, { ongoingId, force = false } = {}) {
    const id = key(ongoingId)
    if (!id || !rootGetters?.['user/isAuthenticated']) return
    const known = s.byId[id]
    if (!force && known && known.status !== 'error') return
    commit('SET', { id, status: 'loading', data: known?.data || null })
    try {
      const data = unwrap(await api.get('chat/sessions', { scope: scopeString({ ongoingId: id }), take: CONVERSATIONS_TAKE }))
      commit('SET', { id, status: 'ready', data: data || {} })
    } catch {
      commit('SET', { id, status: 'error', data: known?.data || null })
    }
  },
}

export const mutations = {
  SET(s, { id, status, data }) { s.byId = { ...s.byId, [id]: { status, data } } },
}
